/**
 * ClinicTags — compact chip row surfacing a clinic's real + manual-CRM state.
 *
 * Tags come from buildClinicTags(row) (shared/nivDerived): plan, paying,
 * solo/multi, trial days, paid-until. `compact` shows only plan + paying;
 * `keys` (optional array) restricts to specific tag keys.
 */

import { buildClinicTags } from "./nivDerived";
import "./ClinicTags.css";

const COMPACT_KEYS = new Set(["plan", "paying"]);

function ClinicTags({ row, compact = false, keys = null }) {
  if (!row) return null;
  const tags = buildClinicTags(row);
  let visible = compact ? tags.filter((t) => COMPACT_KEYS.has(t.key)) : tags;
  if (Array.isArray(keys)) {
    const allowed = new Set(keys);
    visible = visible.filter((t) => allowed.has(t.key));
  }
  if (visible.length === 0) return null;

  return (
    <div className={`nivtag-row${compact ? " nivtag-row-compact" : ""}`}>
      {visible.map((tag) => (
        <span key={tag.key} className={`nivtag nivtag-${tag.tone}`}>
          {tag.label}
        </span>
      ))}
    </div>
  );
}

export default ClinicTags;
